<template>
    <v-row
        justify="center"
        class="mb-2 d-print-none"
        v-if="bulletins && bulletins.length"
    >
        <v-col cols="12">
            <v-expansion-panels
                focusable
                popout
                multiple
                v-model="expandedPanels"
            >
                <v-expansion-panel
                    v-for="(bulletin, index) in bulletins"
                    :key="bulletin.id"
                >
                    <v-expansion-panel-header
                        :class="bulletin.is_read ? 'py-0 shrink' : ''"
                    >
                        <span :class="bulletin.is_read ? '' : 'text-h6'"
                            >Service Update</span
                        >
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div v-html="bulletin.body" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
    </v-row>
</template>

<script>
import { POST_BULLETIN_READ } from "../../../store/actions.type";

export default {
    name: "MainBulletin",
    data() {
        return {
            expandedPanels: [],
        };
    },
    computed: {
        bulletins() {
            return this.$store.getters.getMainBulletins;
        },
    },
    watch: {
        expandedPanels(newVal) {
            newVal.forEach((index) => {
                if (this.bulletins[index] && !this.bulletins[index].is_read) {
                    this.$store.dispatch(
                        POST_BULLETIN_READ,
                        this.bulletins[index].id
                    );
                }
            });
        },
    },
};
</script>

<style scoped>
.shrink {
    min-height: 24px !important;
}
</style>
